import {
  TypeKeys,
} from "../../../domain/document/items";

import {
  BeanTypes,
} from "./beans/items";

import {
  IObjectTranslatable,
  BoxLineItemTranslator,
  CircleItemTranslator,
  TextBoxItemTranslator,
  MovableTextBoxItemTranslator,
  CircleSelectItemTranslator,
  DateItemTranslator,
  LineItemTranslator,
  CalculateItemTranslator,
  CheckBoxItemTranslator,
  NotImplementedItemTranslator,
  ComboBoxItemTranslator,
  RollItemTranslator,
  BarcodeItemTranslator,
  ExternalDataItemTranslator,
  ExternalProcessItemTranslator,
  PositionCorrectItemTranslator,
  RichTextBoxItemTranslator,
  ImageItemTranslator,
  TriangleItemTranslator,
  MovableImageItemTranslator,
  CrossItemTranslator,
  PolylineItemTranslator,
  NewPageItemTranslator,
  GraphItemTranslator,
  HeaderFooterTextItemTranslator,
  JoinTextItemTranslator,
  BarItemTranslator,
  SignItemTranslator,
  StampItemTranslator,
} from "./translators";

export class TranslatorRepository {
  private static CreateTranslators(getToken: () => string): { [key: string]: IObjectTranslatable; } {
    const results: { [key: string]: IObjectTranslatable; } = {};
    results[TypeKeys.BoxLineItem] = new BoxLineItemTranslator();
    results[TypeKeys.CircleItem] = new CircleItemTranslator();
    results[TypeKeys.TextBoxItem] = new TextBoxItemTranslator();
    results[TypeKeys.CircleSelectItem] = new CircleSelectItemTranslator();
    results[TypeKeys.DateItem] = new DateItemTranslator();
    results[TypeKeys.LineItem] = new LineItemTranslator();
    results[TypeKeys.PolylineItem] = new PolylineItemTranslator();
    results[TypeKeys.CalculateItem] = new CalculateItemTranslator();
    results[TypeKeys.CheckBoxItem] = new CheckBoxItemTranslator();
    results[TypeKeys.ComboBoxItem] = new ComboBoxItemTranslator();
    results[TypeKeys.MovableTextBoxItem] = new MovableTextBoxItemTranslator();
    results[TypeKeys.RollItem] = new RollItemTranslator();
    results[TypeKeys.BarcodeItem] = new BarcodeItemTranslator();
    results[TypeKeys.ExternalDataItem] = new ExternalDataItemTranslator();
    results[TypeKeys.ExternalProcessItem] = new ExternalProcessItemTranslator();
    results[TypeKeys.PositionCorrectItem] = new PositionCorrectItemTranslator();
    results[TypeKeys.RichTextBoxItem] = new RichTextBoxItemTranslator();
    results[TypeKeys.ImageItem] = new ImageItemTranslator(getToken);
    results[TypeKeys.SignItem] = new SignItemTranslator(getToken);
    results[TypeKeys.TriangleItem] = new TriangleItemTranslator();
    results[TypeKeys.MovableImageItem] = new MovableImageItemTranslator(getToken);
    results[TypeKeys.CrossItem] = new CrossItemTranslator();
    results[TypeKeys.NewPageItem] = new NewPageItemTranslator();
    results[TypeKeys.GraphItem] = new GraphItemTranslator();
    results[TypeKeys.HeaderFooterTextItem] = new HeaderFooterTextItemTranslator();
    results[TypeKeys.JoinTextItem] = new JoinTextItemTranslator();
    results[TypeKeys.BarItem] = new BarItemTranslator();
    results[TypeKeys.StampItem] = new StampItemTranslator(getToken);
    return results;
  }

  private static CreateTypes(): { [key: string]: string; } {
    const results: { [key: string]: string; } = {};
    results[BeanTypes.Rect] = TypeKeys.BoxLineItem;
    results[BeanTypes.Ellipse] = TypeKeys.CircleItem;
    results[BeanTypes.Text] = TypeKeys.TextBoxItem;
    results[BeanTypes.CircleSelect] = TypeKeys.CircleSelectItem;
    results[BeanTypes.Date] = TypeKeys.DateItem;
    results[BeanTypes.Line] = TypeKeys.LineItem;
    results[BeanTypes.FreeLine] = TypeKeys.PolylineItem;
    results[BeanTypes.Calculate] = TypeKeys.CalculateItem;
    results[BeanTypes.Check] = TypeKeys.CheckBoxItem;
    results[BeanTypes.List] = TypeKeys.ComboBoxItem;
    results[BeanTypes.MovableText] = TypeKeys.MovableTextBoxItem;
    results[BeanTypes.Roll] = TypeKeys.RollItem;
    results[BeanTypes.Barcode] = TypeKeys.BarcodeItem;
    results[BeanTypes.ExternalData] = TypeKeys.ExternalDataItem;
    results[BeanTypes.ExternalProcess] = TypeKeys.ExternalProcessItem;
    results[BeanTypes.PosCorrect] = TypeKeys.PositionCorrectItem;
    results[BeanTypes.RichText] = TypeKeys.RichTextBoxItem;
    results[BeanTypes.Image] = TypeKeys.ImageItem;
    results[BeanTypes.Sign] = TypeKeys.SignItem;
    results[BeanTypes.Triangle] = TypeKeys.TriangleItem;
    results[BeanTypes.MovableImage] = TypeKeys.MovableImageItem;
    results[BeanTypes.Cross] = TypeKeys.CrossItem;
    results[BeanTypes.NewPage] = TypeKeys.NewPageItem;
    results[BeanTypes.Graph] = TypeKeys.GraphItem;
    results[BeanTypes.HeaderFooterText] = TypeKeys.HeaderFooterTextItem;
    results[BeanTypes.JoinText] = TypeKeys.JoinTextItem;
    results[BeanTypes.Bar] = TypeKeys.BarItem;
    results[BeanTypes.Stamp] = TypeKeys.StampItem;
    return results;
  }

  constructor(getToken: () => string) {
    this._translators = TranslatorRepository.CreateTranslators(getToken);
    this._types = TranslatorRepository.CreateTypes();
  }

  private _translators: { [key: string]: IObjectTranslatable; };
  private _notImplementedItemTranslator: NotImplementedItemTranslator = new NotImplementedItemTranslator();

  getTranslatorByTypeKey(typeKey: string): IObjectTranslatable {
    if (!typeKey) {
      console.warn("empty item type");
      return this._notImplementedItemTranslator;
    }
    if (!(typeKey in this._translators)) {
      console.warn("unknown item type: " + typeKey);
      return this._notImplementedItemTranslator;
    }
    return this._translators[typeKey];
  }

  getTranslatorByBeanType(beanType: string): IObjectTranslatable {
    const typeKey = this.getTypeKeyFromBeanType(beanType);
    return this.getTranslatorByTypeKey(typeKey);
  }

  private _types: { [key: string]: string; };

  getTypeKeyFromBeanType(beanType: string): string {
    if (!beanType) {
      console.warn("empty bean type");
      return null;
    }
    if (!(beanType in this._types)) {
      console.warn("unknown bean type: " + beanType);
      return null;
    }
    return this._types[beanType];
  }
}
